export * from './LocatorMap';
export { default as LocatorMap } from './LocatorMap';
